import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "../styles/Contactpage.css";
import indiagate from "../assets/images/india-gate.svg";
import email from "../assets/images/mail-contact.svg";
import phone from "../assets/images/whatsapp-contact.svg";

function ContactSection() {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);

  // ✅ EmailJS init (do this once)
  emailjs.init("YWyfWV3Y-YTiC109P");

  // ✅ CUSTOM ALERT (same as Contact page)
  const showAlert = (type, message) => {
    const alertBox = document.createElement("div");
    alertBox.className = `custom-alert ${type}`;
    alertBox.innerHTML = `
      <span class="alert-icon">${type === "success" ? "" : "❌"}</span>
      <span class="alert-text">${message}</span>
    `;
    document.body.appendChild(alertBox);

    setTimeout(() => {
      alertBox.remove();
    }, 4500);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm("service_jlh6tvr", "template_20mxpjm", formRef.current)
      .then(() => {
        showAlert(
          "success",
          "Message sent successfully! We'll get back to you soon.",
        );
        formRef.current.reset();
        setLoading(false);
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);
        showAlert("error", "Failed to send message. Please try again later.");
        setLoading(false);
      });
  };

  return (
    <section className="contact-contt">
      <h2 className="contact-heading-con">
        Partner With Us for Digital Success
      </h2>

      <div className="contact-con">
        <div className="contact-cardd">
          <div className="iconn">
            <img src={indiagate} alt="India Gate" />
          </div>
          <span className="tagg">Corporate Office</span>
          <h3>Noida</h3>
          <p className="address">Sector-62, Noida, India</p>
          <div className="call-box">
            <p>Speak with us</p>
            <h4>+91 8368327503</h4>
          </div>
        </div>

        <div className="contact-cardd">
          <h3>Sales Enquiry</h3>
          <div className="enquiry-item">
            <span className="enquiry-icon">
              <img src={email} alt="Email" />
            </span>
            <div>
              <p>Email us</p>
              <a href="mailto:connect@empowerweb.in">
                connect@empowerweb.in
              </a>
            </div>
          </div>
          <div className="enquiry-item">
            <span className="enquiry-icon">
              <img src={phone} alt="WhatsApp" />
            </span>
            <div>
              <p>WhatsApp</p>
              <a href="tel:+918368327503">+91 8368327503</a>
            </div>
          </div>
        </div>

        <div className="form-card">
          {/* <form ref={formRef} onSubmit={sendEmail}>
            <div className="form-roww">
              <input
                type="text"
                name="name"
                placeholder="Name *"
                required
                disabled={loading}
              />
              <input
                type="email"
                name="email"
                placeholder="Email Id *"
                required
                disabled={loading}
              />
            </div>

            <div className="form-roww">
              <input
                type="tel"
                name="phone"
                placeholder="Mobile No *"
                pattern="[0-9]{10}"
                title="Please enter a valid 10-digit mobile number"
                required
                disabled={loading}
              />
              <select name="service" required disabled={loading}>
                <option value="">Choose Services</option>
                <option value="Web Development">Web Development</option>
                <option value="SEO Services">SEO Services</option>
                <option value="Social Media Marketing">
                  Social Media Marketing
                </option>
                <option value="Paid Ads">Paid Ads</option>
              </select>
            </div>

            <textarea
              name="message"
              placeholder="Type Your Message"
              rows="5"
              required
              disabled={loading}
            />

            <button
              type="submit"
              className="submit-btnn"
              disabled={loading}
            >
              {loading ? "Sending..." : "Submit Now →"}
            </button>
          </form> */}
          <form ref={formRef} onSubmit={sendEmail} className="contact-form">
            <div className="form-roww">
              <div className="form-group">
                <label htmlFor="name">Name *</label>
                <input
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Name"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Id *</label>
                <input
                  id="email"
                  type="email"
                  name="email"
                  placeholder="Email"
                  required
                  disabled={loading}
                />
              </div>
            </div>

            <div className="form-roww">
              <div className="form-group">
                <label htmlFor="phone">Mobile No *</label>
                <input
                  id="phone"
                  type="tel"
                  name="phone"
                  placeholder="Mobile Number"
                  pattern="[0-9]{10}"
                  title="Please enter a valid 10-digit mobile number"
                  required
                  disabled={loading}
                />
              </div>

              <div className="form-group">
                <label htmlFor="service">Choose Service *</label>
                <select id="service" name="service" required disabled={loading}>
                  <option value="">Select a service</option>
                  <option value="Web Development">Web Development</option>
                  <option value="SEO Services">SEO Services</option>
                  <option value="Social Media Marketing">
                    Social Media Marketing
                  </option>
                  <option value="Paid Ads">Paid Ads</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                placeholder="Type your message..."
                rows="5"
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="submit-btnn" disabled={loading}>
              {loading ? "Sending..." : "Submit Now →"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactSection;
